import { Button } from "@heroui/react";
import { IconEye } from "@tabler/icons-react";
import { useCallback, useState } from "react";
import { ResumePreviewModal } from "../resume-preview";

interface PreviewButtonProps {
    onPreview?: () => void;
}

export function PreviewButton({ onPreview }: PreviewButtonProps) {
    const [isModalOpen, setIsModalOpen] = useState(false);

    const handlePreview = useCallback(() => {
        if (onPreview) {
            onPreview();
        }
        setIsModalOpen(true);
    }, [onPreview]);

    const handleClose = useCallback(() => setIsModalOpen(false), []);

    return (
        <>
            <Button
                type="button"
                className="rounded-full bg-transparent p-2 transition duration-200 hover:bg-gray-200"
                onPress={handlePreview}
                startContent={
                    <IconEye
                        stroke={1.5}
                        size={20}
                        className="transform text-default-500 transition delay-100 duration-200"
                    />
                }
            >
                Vorschau ansehen
            </Button>

            <ResumePreviewModal isOpen={isModalOpen} onClose={handleClose} />
        </>
    );
}
